export default __webpack_public_path__ + "static/media/plagiarismdetectorimg.4f62b1e3.png";